<template>
<v-row>
    <v-col cols="1"></v-col>
    <v-col cols="10">
        <v-card-text class="">
            <h2 class="indigo--text text--darken-4"><u>Langues</u></h2>
            <br>
            <v-item-group>
                <v-container>
                    <v-row>
                        <v-col cols="6" v-for="(item, index) in items" :key="index">
                            <v-item>
                                <v-card color="blue-grey lighten-5">
                                    <v-card-title>
                                        <v-avatar>
                                            <v-img :src="getImgFlag(item.icon)" width="64"></v-img>
                                        </v-avatar>
                                        <span class="pl-5">{{ item.label }} :</span> 
                                        <span class="pl-7">{{ item.level }}</span>
                                    </v-card-title>
                                    
                                </v-card>
                            </v-item>
                        </v-col>
                    </v-row>
                </v-container>
            </v-item-group>
        </v-card-text>
    </v-col>
    <v-col cols="1"></v-col>
</v-row>
</template>

<script>
export default {
    name: 'Languages',
    data: () => ({
        items: [
            { code:'en', label:'Anglais', level:'courant', icon:'united_kingdom_round_icon_64.png' },
            { code:'de', label:'Allemand', level:'scolaire', icon:'germany_round_icon_64.png' },
        ]
    }),
    methods: {
        getImgFlag(pic) 
        {
            return require('@/assets/flags/'+pic)
        }
    }
}
</script>
